// removed by extract-text-webpack-plugin
module.exports = {"container":"_1MaR2JGutIny_nT-sQRXWD","errorDetail":"_1jeNXWaaPg05JF6wuUzMGt"};


//////////////////
// WEBPACK FOOTER
// ./src/ServerErrorView/ServerErrorView.css
// module id = 211
// module chunks = 0